import { Pipe, PipeTransform } from '@angular/core';

import { formatMoney } from './money-format.util';

@Pipe({
  name: 'money',
  standalone: true,
})
export class MoneyPipe implements PipeTransform {
  transform(value: unknown): string {
    return formatMoney(value);
  }
}
